import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "App";

import Auth0ProviderWithNavigate from 'services/auth/Auth0';
import { withAuthenticationRequired } from "@auth0/auth0-react"; // 1. Import the HOC

// Soft UI Context Provider
import { SoftUIControllerProvider } from "hooks/context";

import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query'

import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

// Create a client
const queryClient = new QueryClient();

// 2. Create a Protected wrapper for your App component
const ProtectedApp = withAuthenticationRequired(App, {
  onRedirecting: () => (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      Loading / Redirecting to login...
    </div>
  ),
});

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter> {/* Moved to the absolute top */}
    <Auth0ProviderWithNavigate>
      <QueryClientProvider client={queryClient}>
        <SoftUIControllerProvider>
          
          <App />
          
        </SoftUIControllerProvider>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </Auth0ProviderWithNavigate>
  </BrowserRouter>
);